import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Input, Label, Spinner, Table } from "reactstrap";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import {
  CallHistoryTitle,
  TransitionHistoryTitle,
} from "../../../../Utils/Constants";
import TransitionHistoryBody from "./TransitionHistoryBody";
import axios from "axios";
import { baseUrl } from "../../../../Utils/FileUpload";

// Replace with actual token or state

export default function TransitionHistory() {
  const [filterText, setFilterText] = useState("");
  const [callHistoryData, setCallHistoryData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
  const token = localStorage.getItem("token");

        const response = await axios.get(`${baseUrl}call_history/get_call_history`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
// console.log(response.data.data)
        // Map to ensure agent & customer are properly assigned
        const enhancedData = response.data.data.slice(0, 8);

        setCallHistoryData(enhancedData);
      } catch (error) {
        console.error("Error fetching call history:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);


  const isLargeScreen = windowWidth >= 1200; // xxl/xl screens
  const callHistoryHead = isLargeScreen
    ? ["Customer Mobile", "", "Agent Name", "Amount", "Duration"]
    : ["Customer Mobile", "Agent Name", "Amount", "Duration"];

  return (
    <Col xxl={5} xl={7} lg={7} md={7} sm={12} >
      <Card>
        <CommonCardHeader
          title={CallHistoryTitle}
          headClass="card-no-border pb-0"
        />
        <CardBody className="transaction-history pt-0">
          <div className="table-responsive theme-scrollbar">
            <div className="dataTables_wrapper no-footer">
              <div id="transaction_filter" className="dataTables_filter">
                <Label className="d-flex">
                  {" "}
                  Search:
                  <Input
                    type="search"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </Label>
              </div>
              <Table
                className="display table-bordernone dataTable no-footer"
                id="transaction"
              >
                <thead>
                  <tr role="row">
                    {callHistoryHead.map((head, index) => (
                      <th
                        key={index}
                        className="sorting_disabled"
                        rowSpan={1}
                        colSpan={1}
                      >
                        {head}
                      </th>
                    ))}
                  </tr>
                </thead>
                <TransitionHistoryBody
                  data={callHistoryData}
                  filterText={filterText}
                  loading={loading}
                  isLargeScreen={isLargeScreen}
                />
              </Table>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}



// import React, { useState } from 'react'
// import { Card, CardBody, Col, Input, Label, Table } from 'reactstrap'
// import CommonCardHeader from '../../../../Utils/CommonComponents/CommonCardHeader'
// import { TransitionHistoryTitle } from '../../../../Utils/Constants'
// import { transitionHistoryHead } from '../../../../Data/Dashboard/Default';
// import TransitionHistoryBody from './TransitionHistoryBody';

// export default function TransitionHistory() {
//     const [filterText, setFilterText] = useState('');

//     return (
//         <Col xxl={6} xl={8} lg={12} md={6} className="proorder-xxl-8 box-col-7">
//             <Card>
//                 <CommonCardHeader title={TransitionHistoryTitle} headClass="card-no-border pb-0" />
//                 <CardBody className="transaction-history pt-0">
//                     <div className="table-responsive theme-scrollbar">
//                         <div className="dataTables_wrapper no-footer">
//                             <div id="transaction_filter" className="dataTables_filter">
//                                 <Label className='d-flex'> Search:
//                                     <Input type="search" value={filterText} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} />
//                                 </Label>
//                             </div>
//                             <Table className="display table-bordernone dataTable no-footer" id="transaction">
//                                 <thead>
//                                     <tr role='row'>
//                                         {transitionHistoryHead.map((item, index) => (
//                                             <th key={index} className={`sorting_disabled ${index === 4 ? 'text-center' : ''}`} rowSpan={1} colSpan={1}>
//                                                 {item}
//                                             </th>
//                                         ))}
//                                     </tr>
//                                 </thead>
//                                 <TransitionHistoryBody filterText={filterText} />
//                             </Table>
//                         </div>
//                     </div>
//                 </CardBody>
//             </Card>
//         </Col>
//     )
// }
